"use strict";
exports.__esModule = true;
var trapFocus = function (e, ref) {
    var focusableModalElements = ref.current.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
    var firstFocusableEl = focusableModalElements[0];
    var lastFocusableEl = focusableModalElements[focusableModalElements.length - 1];
    if (e.shiftKey) {
        /* shift tab keypress */
        if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
        }
    } /* tab keypress */
    else if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
    }
};
exports["default"] = trapFocus;
